import { useEffect, useState } from 'react';
import AdminLayout from '../AdminLayout';
import { getBannersAdmin, addBanner, updateBanner, deleteBanner } from '../../services/adminService';
import { uploadToCloudinary } from '../../utils/uploadToCloudinary';

export default function AdminBanners() {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({ Image: '', Link: '' });
  const [uploading, setUploading] = useState(false);
  const [saving, setSaving] = useState(false);

  const load = () => getBannersAdmin().then(d => { setBanners(d); setLoading(false); });
  useEffect(() => { load(); }, []);

  const handleFile = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploading(true);
    try {
      const url = await uploadToCloudinary(file);
      setForm(f => ({ ...f, Image: url }));
    } catch { alert('Upload failed. Check Cloudinary credentials in .env'); }
    finally { setUploading(false); }
  };

  const handleAdd = async (e) => {
    e.preventDefault();
    if (!form.Image || !form.Link) return;
    setSaving(true);
    await addBanner({ ...form, order: banners.length });
    setForm({ Image: '', Link: '' });
    await load();
    setSaving(false);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this banner?')) return;
    await deleteBanner(id);
    setBanners(prev => prev.filter(b => b.id !== id));
  };

  return (
    <AdminLayout title="Home Banners">
      <div className="admin-section">
        <div className="admin-section-header"><h2>Add New Banner</h2></div>
        <div className="admin-section-body">
          <form className="admin-form" onSubmit={handleAdd}>
            <div className="admin-form-row">
              <div>
                <label>Banner Image</label>
                <label className="upload-box">
                  <input type="file" accept="image/*" onChange={handleFile} />
                  {uploading ? <p>Uploading…</p> : form.Image ? <img src={form.Image} alt="" style={{ maxHeight: 80 }} /> : <p>Click to upload image</p>}
                </label>
              </div>
              <div>
                <label>Destination Link (URL)</label>
                <input type="url" placeholder="https://..." value={form.Link} onChange={e => setForm(f => ({ ...f, Link: e.target.value }))} required />
              </div>
            </div>
            <div>
              <button className="a-btn a-btn-primary" type="submit" disabled={saving || uploading || !form.Image}>
                {saving ? 'Saving…' : 'Add Banner'}
              </button>
            </div>
          </form>
        </div>
      </div>

      <div className="admin-section">
        <div className="admin-section-header"><h2>Current Banners ({banners.length})</h2></div>
        <div className="admin-section-body">
          {loading ? <div className="admin-spinner">Loading…</div> : (
            banners.length === 0 ? <div className="admin-empty">No banners yet</div> : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                {banners.map((b, i) => (
                  <div key={b.id} className="admin-list-item">
                    <img src={b.Image} alt="" className="img-preview" style={{ width: 120, height: 70 }} />
                    <div className="admin-list-item-content">
                      <div style={{ fontSize: 13, color: 'var(--a-text-muted)' }}>Order: {b.order}</div>
                      <div style={{ fontSize: 13, wordBreak: 'break-all' }}>→ {b.Link}</div>
                    </div>
                    <div className="admin-list-item-actions">
                      <button className="a-btn a-btn-sm a-btn-danger" onClick={() => handleDelete(b.id)}>Delete</button>
                    </div>
                  </div>
                ))}
              </div>
            )
          )}
        </div>
      </div>
    </AdminLayout>
  );
}
